import { render, staticRenderFns } from "./IconWaveHome.vue?vue&type=template&id=5e0e747e&"
import script from "./IconWaveHome.vue?vue&type=script&lang=js&"
export * from "./IconWaveHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports